import { __decorate } from "tslib";
import Component from 'vue-class-component';
import Vue from 'vue';
import CsvUploadStep from '@/components/multipayout/CsvUploadStep.vue';
import PayoutFormStep from '@/components/multipayout/PayoutFormStep.vue';
import PayoutSummaryStep from '@/components/multipayout/PayoutSummaryStep.vue';
import { netAmount } from '@/types/MultiPayoutTypes';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import { BALANCES } from '@/constants/Balances';
import moment from 'moment';
let MultiPayout = class MultiPayout extends Vue {
    step = 1;
    payoutRows = [];
    submitting = false;
    snackbar = { show: false, text: '', color: '' };
    onCsvImport(rows) {
        this.payoutRows = rows;
        this.step = 2;
    }
    onCsvSkip() {
        this.payoutRows = [];
        this.step = 2;
    }
    onFormNext(rows) {
        this.payoutRows = rows;
        this.step = 3;
    }
    async onConfirm() {
        const totalNet = this.payoutRows.reduce((sum, r) => sum + netAmount(r), 0);
        if (!await ConfirmDialog.open('Potvrzení výplaty', `Opravdu chcete vyplatit ${this.payoutRows.length} instruktorů za celkem ${totalNet} Kč?`))
            return;
        this.submitting = true;
        try {
            const transactions = [];
            const now = moment().format('YYYY-MM-DD HH:mm:ss');
            for (const row of this.payoutRows) {
                const net = netAmount(row);
                if (net > 0) {
                    transactions.push({
                        id: 'new-transaction',
                        data: {
                            from: row.instructorId,
                            to: 'cash',
                            value: net,
                            dateTime: now,
                            createdAt: now,
                            category: 'payout',
                            description: 'Hromadná výplata',
                        },
                    });
                }
                if (row.tax > 0) {
                    transactions.push({
                        id: 'new-transaction',
                        data: {
                            from: row.instructorId,
                            to: BALANCES.TAX_BALANCE,
                            value: row.tax,
                            dateTime: now,
                            createdAt: now,
                            category: 'payout',
                            description: 'Daň',
                        },
                    });
                }
            }
            await this.$store.dispatch('transaction/store', transactions);
            this.snackbar = { show: true, text: 'Výplaty byly úspěšně zpracovány', color: 'success' };
            this.$router.push({ name: 'Transactions' });
        }
        catch (e) {
            console.error(e);
            this.snackbar = { show: true, text: 'Chyba při zpracování výplat', color: 'error' };
        }
        finally {
            this.submitting = false;
        }
    }
};
MultiPayout = __decorate([
    Component({
        components: {
            CsvUploadStep,
            PayoutFormStep,
            PayoutSummaryStep,
        },
    })
], MultiPayout);
export default MultiPayout;
